import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login.vue' // 登录页面
import Dashboard from '@/views/admin/dashboard/index.vue'
import Layout from '@/components/Layout.vue' //  带top菜单的布局
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/', // 登录页面
      component: Login
    },
    {
      path: '/Dashboard', // 登录页面
      component: Dashboard
    },


    {
      path: '/login', // 登录页面
      component: Login
    },
    {
      name: '主页',
      path: '/home',
      redirect: '/home/index',
      role_name: ['超级管理员'],
      component: Layout,
      children: [
        {
          path: 'index',
          name: '数据面板', // 子路由的 name
          component: () => import('@/views/admin/home/home.vue')
        }
      ]
    },
    {
      name: '小程序内容',
      path: '/xcx',
      redirect: '/xcx/index',
      role_name: ['超级管理员'],
      component: Layout,
      children: [
        {
          path: 'index',
          name: '首页数据', // 子路由的 name
          component: () => import('@/views/admin/xcx/index.vue')
        }
      ]
    },

    {
      name: '用户',
      path: '/users',
      redirect: '/users/list',
      role_name: ['超级管理员'],
      component: Layout,
      children: [
        {
          path: 'list',
          name: '账号管理', // 子路由的 name
          component: () => import('@/views/admin/users/list.vue')
        },
        {
          path: 'details',
          hidden: true,
          name: '账号详情', // 子路由的 name
          component: () => import('@/views/admin/users/details.vue')
        },
        {
          path: 'data_clerk',
          name: '资料员权限', // 子路由的 name
          component: () => import('@/views/admin/users/data_clerk.vue')
        },
      ]
    },





    {
      name: '数据管理',
      path: '/data',
      redirect: '/data/userList',
      role_name: ['超级管理员', '管理员'],
      component: Layout,
      children: [
        // {
        //   path: 'Homeowner',
        //   name: '居民列表', // 子路由的 name
        //   component: () => import('@/views/admin/form/user_list.vue')
        // },



        {
          path: 'userList',
          name: '居民信息', // 子路由的 name
          component: () => import('@/views/admin/form/user_list.vue')
        },
        {
          path: 'companyList',
          name: '企业资料', // 子路由的 name
          component: () => import('@/views/admin/form/company_list.vue')
        },
      ]
    },
    {
      name: '地区管理',
      path: '/region',
      redirect: '/region/list',
      role_name: ['超级管理员'],
      component: Layout,
      children: [
        {
          path: 'list',
          name: '地区列表', // 子路由的 name
          component: () => import('@/views/admin/region/list.vue')
        },
        {
          path: 'sublist',
          hidden: true,
          name: '地区详情', // 子路由的 name
          component: () => import('@/views/admin/region/sublist.vue')
        }
      ]
    },

    {
      name: '后台管理员',
      path: '/admins',
      redirect: '/admins/list',
      role_name: ['超级管理员'],
      component: Layout,
      children: [
        {
          path: 'list',
          name: '管理员列表', // 子路由的 name
          component: () => import('@/views/admin/admins/list.vue')
        },
        {
          path: 'auth',
          name: '地区权限', // 子路由的 name
          component: () => import('@/views/admin/admins/auth.vue')
        }
      ]
    },


    // {
    //   name: '表单配置',
    //   role_name: ['超级管理员'],
    //   path: '/form',
    //   redirect: '/form/user',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'user',
    //       name: '村民表单',
    //       role_name: ['超级管理员'],
    //       component: () => import('@/views/admin/form/user.vue')
    //     },
    //     {
    //       path: 'data_clerk',
    //       name: '资料员表单',
    //       role_name: ['超级管理员'],
    //       component: () => import('@/views/admin/form/data_clerk.vue')
    //     },




    //   ]
    // },

    {
      name: '系统管理',
      role_name: ['超级管理员'],
      path: '/sys',
      redirect: '/sys/SysSeting',
      component: Layout,
      children: [
        {
          path: 'SysSeting',
          name: '基础设置',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/sys/seting.vue')
        },
        {
          path: 'AdminList',
          name: '管理员列表',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/admins/list.vue')
        },
        {
          path: 'AdminLog',
          name: '管理员日志',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/log/admin.vue')
        },


        {
          path: 'user_config',
          name: '村民表单',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/form/user_config.vue')
        },
        // {
        //   path: 'data_clerk',
        //   name: '资料员表单',
        //   role_name: ['超级管理员'],
        //   component: () => import('@/views/admin/form/data_clerk.vue')
        // },

        {
          path: 'company_config',
          name: '企业收集表单',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/form/company_config.vue')
        },



        {
          path: 'dashboard_config',
          name: '数据大屏配置',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/dashboard/config.vue')
        },







        //还没写完
        // {
        //   path: 'UserLog',
        //   name: '用户日志',
        //   role_name: ['超级管理员'],
        //   component: () => import('@/views/admin/log/user.vue')
        // }
      ]
    },
    // {
    //   name: '开发配置',
    //   role_name: ['超级管理员'],
    //   component: Layout,
    //   path: '/dev', // 页面开发
    //   redirect: '/dev/lists',
    //   children: [
    //     {
    //       path: 'lists',
    //       name: '页面列表', // 子路由的 name
    //       component: () => import('@/views/dev/index.vue')
    //     },
    //     {
    //       hidden: true,
    //       path: 'info',
    //       name: '页面详情', // 子路由的 name
    //       component: () => import('@/views/dev/info.vue')
    //     },


    //   ]
    // },
    {
      path: '*', // 默认路由，匹配所有未定义的路由
      redirect: '/' // 重定向到公共页面
    }
  ]
})
